import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`This policy describes npm logos and trademarks and how you may use them.
For information on what to do if someone infringes a trademark of
`}<em parentName="p">{`yours`}</em>{` with a confusing package name, see the `}<a parentName="p" {...{
        "href": "/policies/disputes"
      }}>{`Disputes policy`}</a>{`.`}</p>
    <h2>{`What is npm?`}</h2>
    <p>{`The npm project contains two main parts:`}</p>
    <ol>
      <li parentName="ol">{`The npm client. It is a command line tool to install and publish packages.`}</li>
      <li parentName="ol">{`The npm registry service. npm, Inc. runs the registry as a free (as in beer) public service for anyone
wanting to publish an open source package and for anyone to install an open source package.`}</li>
    </ol>
    <h2>{`Why npm, Inc. has a logo policy`}</h2>
    <p>{`"npm" and the npm logos are trademarks owned by npm, Inc. We have developed this policy to make it clear how other businesses and projects can (and cannot) use the npm name and logos.`}</p>
    <h2>{`General rules`}</h2>
    <ul>
      <li parentName="ul">{`When referring to the npm software in body text, the first usage should be followed by a generic term such as "package manager," "services" or "client" to provide context.`}</li>
      <li parentName="ul">{`"npm" should never be used or explained as an acronym.`}</li>
      <li parentName="ul">{`When referring to the npm public registry, please follow npm with the word "registry" or the phrase "public registry".`}</li>
      <li parentName="ul">{`When referring to a private registry for npm packages, please describe it as "private registry for npm packages" or a "proxy of the npm registry".`}</li>
      <li parentName="ul">{`References to the owner of the npm client software and the operator of the npm public registry should be to "npm, Inc."`}</li>
      <li parentName="ul">{`Any materials referring to npm should include the following notice in the footer or wherever you may have your own trademark notice: "npm is a registered trademark of npm, Inc."`}</li>
    </ul>
    <h2>{`Nominative use - No need to type ™ on Twitter`}{`®`}</h2>
    <p>{`"Nominative" or "referential" use means to refer to something or someone else by their trademark. So it's perfectly OK to use "npm" to refer to npm, Inc., the npm client, npm code, and the npm public registry. A referential use is generally going to be in a sentence or sentence fragment, like "first install the npm client," or in a book or article title. The use should not be attention-getting or potentially misperceived as suggesting "npm" is your own name, project, product or services.`}</p>
    <p>{`It is not a referential use to incorporate the letters "npm" or any of the npm logos in the name or logo for your own company or its projects, products, services or social media handles.`}</p>
    <p>{`If you need to use "npm" to indicate compatibility, you should use "npm" after your own product or service name and an accurate preposition:`}</p>
    <ul>
      <li parentName="ul">{`Pink Unicorn Consulting Ltd. services `}<strong>{`for`}</strong>{` npm`}</li>
      <li parentName="ul">{`Purple Unicorn Inc. private registry server `}<strong>{`compatible with`}</strong>{` the npm client`}</li>
      <li parentName="ul">{`Kappa, a hirearchical proxy `}<strong>{`of`}</strong>{` the npm registry`}</li>
    </ul>
    <p>{`You need to ask for permission for any uses not described. When in doubt about your use of the npm name or logo, please contact `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/contact"
      }}>{`npm, Inc.`}</a>{` for clarification.`}</p>
    <h2>{`Requesting permission`}</h2>
    <p>{`We like to make it easy for anyone to use the npm name or logo for community-oriented efforts that help spread and improve npm. We are therefore likely to grant permission to use the npm name and logo in the following ways:`}</p>
    <ul>
      <li parentName="ul">{`For projects where:`}
        <ul parentName="li">
          <li parentName="ul">{`The primary purpose of your project is to promote the spread and
improvement of the npm client software or the npm registry service.`}</li>
          <li parentName="ul">{`Your project is non-commercial in nature (it can make money to cover
its costs or contribute to non-profit entities, but it cannot be run
as a for-profit project or business).`}</li>
          <li parentName="ul">{`Your project neither promotes nor is associated with entities that
currently fail to comply with the Artistic License 2.0 under which
npm is distributed, or which are in violation of this policy.`}</li>
        </ul>
      </li>
      <li parentName="ul">{`For a user group name where:`}
        <ul parentName="li">
          <li parentName="ul">{`The main focus of the group is the software.`}</li>
          <li parentName="ul">{`Any software or services the group provides are without cost.`}</li>
          <li parentName="ul">{`The group does not make a profit.`}</li>
          <li parentName="ul">{`Any charge to attend meetings are to cover the cost of the venue, food and drink only.`}</li>
        </ul>
      </li>
    </ul>
    <p>{`Any other requests are not likely to be granted licenses, but feel free to `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/contact"
      }}>{`ask`}</a>{`.`}</p>
    <h2>{`The npm Logos`}</h2>
    <p>{`Our npm Logos are very recognizable and deserve special treatment. In short, the npm logos represent only npm and should not be used to represent your products. The
npm Logos signify us, or a special relationship with us, and you
may use them only with our permission. Since the goal is to avoid
confusion about you being us, or your relationship with us, context
counts. We will `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/contact"
      }}>{`consider requests`}</a>{` on a case-by-case basis. `}</p>
    <h2>{`The npm Wombat Mascot`}</h2>
    <p>{`Like the npm Logo, the npm Wombat graphic is a very recognizable
part of the npm brand, and signifies a special relationship with
the npm project, service, or company.  It should never be used except
with explicit written permission.  We will `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/contact"
      }}>{`consider requests`}</a>{` on a
case-by-case basis.`}</p>
    <p>{`Please be advised that the Wombat and the logos generally may
`}<strong parentName="p">{`not`}</strong>{` be used to refer to the project, service, or company in a
nominative sense, as any usage will almost always imply a special
relationship with npm.`}</p>
    <h2>{`Changes`}</h2>
    <p>{`This is a living document and may be updated from time to time.
Please refer to the `}<a parentName="p" {...{
        "href": "https://github.com/npm/documentation/blob/main/content/policies/logos-and-usage.mdx"
      }}>{`git history for this
document`}</a>{`
to view the changes.`}</p>
    <h2>{`License`}</h2>
    <p>{`Copyright `}{`©`}{` npm, Inc.`}</p>
    <p>{`This document may be reused under a `}<a parentName="p" {...{
        "href": "https://creativecommons.org/licenses/by-sa/4.0/"
      }}>{`Creative Commons
Attribution-ShareAlike
License`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      